import { defineComponent as _defineComponent } from 'vue'
import { toRefs, computed } from "@nuxtjs/composition-api";
import { ExternalWalletPayment } from "~/core/models/purchase-popup-2/ExternalWalletPayment";
import { toCurrencyFormat } from "@/core/helpers/GlobalHelpers";

interface Props {
    transactionObject: ExternalWalletPayment;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ExternalWalletMissingAmount',
  props: {
    transactionObject: null
  },
  setup(__props: any) {

const props = __props as { transactionObject: ExternalWalletPayment };



const {
    transactionObject,
} = toRefs(props);

const mainAsset = computed(() => transactionObject.value.missingAmountAsset);

return { __sfc: true,props, transactionObject, mainAsset, toCurrencyFormat }
}

})